<template>
	<div>Logging out...</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'Logout',
	methods: {
		...mapActions(['logout']),
	},

	async mounted() {
		await this.logout();
	},
};
</script>

<style scoped lang="scss"></style>
